import { render, staticRenderFns } from "./StudyVideo.vue?vue&type=template&id=41baed24&"
import script from "./studyvideo?vue&type=script&lang=js&"
export * from "./studyvideo?vue&type=script&lang=js&"
import style0 from "./StudyVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports